"use strict";

var curryN = require('../function/curryN');
/**
 * Returns unique items in array. Uniqueness is defined by `fn`.
 *
 * @param {Function} fn
 * @param {Array} arr
 * @return {Array}
 *
 * @example
 *
 *      uniqBy(x => x % 2, [1, 2, 2, 3, 4, 5, 5, 5]) // [1, 2]
 */
module.exports = curryN(2, function (fn, arr) {
  if (arr === void 0) {
    arr = [];
  }
  var result = [];
  var unq = Object.create(null);
  for (var i = 0; i < arr.length; i++) {
    var key = fn(arr[i]);
    if (!unq[key]) {
      result.push(arr[i]);
      unq[key] = true;
    }
  }
  return result;
});